/**
 * La barre d'aide du catalogue : comprendre, et lire autrement.
 *
 * Elle ne porte que deux liens, et elle existe pour une raison unique : ces deux
 * liens doivent être là EN PERMANENCE.
 *
 * Tous deux vivaient dans `ShopStatusBanner`, qui fait `if (ordering.open)
 * return null` — il se retire dès que la boutique prend commande, soit du
 * mercredi au samedi 18 h. Autrement dit :
 *
 *  - « Comment ça marche ? » n'était lisible QUE boutique fermée, c'est-à-dire
 *    jamais au moment où un nouveau client essaie de commander et se demande
 *    comment on fonctionne (signalé par Philippe le 14/09/2026) ;
 *  - le lien vers la liste en texte disparaissait de la même façon, alors qu'il
 *    répond à la demande d'une cliente qui perd la vue.
 *
 * Une explication et une aide d'accessibilité ne peuvent pas dépendre de
 * l'heure. Elles ne dépendent pas davantage d'un compte : le menu 👤 n'apparaît
 * qu'une fois connecté, et la personne qui en a besoin n'en a pas forcément.
 *
 * Hors du bloc collant, volontairement : une ligne figée en haut coûte ~28 px à
 * tous les visiteurs sur téléphone, en permanence, pour deux liens que la
 * plupart n'ouvriront pas. En tête du document, un lecteur d'écran les rencontre
 * de toute façon en premier, et le doigt les voit à l'arrivée.
 */
import { useState } from 'react';
import HowItWorksModal from './HowItWorksModal';
import LienListeAccessible from './LienListeAccessible';

export default function BarreAideBoutique() {
  const [showHow, setShowHow] = useState(false);

  return (
    <>
      <div className="flex-shrink-0 border-b border-black/[.06] bg-[#fff8ea] px-4 py-2 text-center text-xs text-[#6b6450]">
        <button
          type="button"
          onClick={() => setShowHow(true)}
          className="font-semibold underline underline-offset-2"
        >
          Comment ça marche&nbsp;?
        </button>
        <span className="mx-2 opacity-50">·</span>
        <LienListeAccessible />
      </div>
      <HowItWorksModal open={showHow} onClose={() => setShowHow(false)} />
    </>
  );
}
